import { render, staticRenderFns } from "./FormSpinbuttonLocale.vue?vue&type=template&id=6525ea6d&"
import script from "./FormSpinbuttonLocale.vue?vue&type=script&lang=js&"
export * from "./FormSpinbuttonLocale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports